import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const chengePoStatusSlice = createApi({
    reducerPath: "chengePoStatus",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        chengePoStatus: builder.query({
            query: (data) => ({ url: "/inventory/api/v1/purchase_order/inprocess", params: data, method: "GET" }),
        }),
    }),
});

export const { useChengePoStatusQuery } = chengePoStatusSlice;
